module.exports = "https://coursera_assets.s3.amazonaws.com/images/2a9c3c90cb28837086797a5ac6ada3ed.png";